"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Separator } from "@/components/ui/separator";
const PulseDivider = () => {
  return <div className="relative w-full h-px bg-border overflow-hidden">
      <motion.div className="absolute top-0 h-full w-[40px] bg-secondary opacity-80" initial={{
      left: "-40px"
    }} animate={{
      left: "100%"
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: "linear",
      repeatDelay: 1
    }} />
    </div>;
};
export default function WhyChoose() {
  return <section data-section-id="22260" id="why-choose" className="bg-background text-foreground relative overflow-hidden flex flex-col justify-center min-h-[60vh]">
      {}
      <div className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 font-mono text-[6rem] md:text-[10rem] leading-none text-foreground/[0.02] select-none pointer-events-none" style={{
      writingMode: "vertical-rl",
      transform: "rotate(180deg) translateY(50%)"
    }} aria-hidden="true">
        VPNGENIX_CORE
      </div>

      {}
      <div className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 font-mono text-[6rem] md:text-[10rem] leading-none text-foreground/[0.02] select-none pointer-events-none" style={{
      writingMode: "vertical-rl"
    }} aria-hidden="true">
        SECURE_NET
      </div>

      {}
      <PulseDivider />

      <div className="container mx-auto px-6 md:px-12 py-24 md:py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.8
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }}>
            {}
            <span className="font-mono text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-muted-foreground block mb-6">
              00//
            </span>

            {}
            <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-8">
              Why Choose VPNGENIX
            </h1>

            {}
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              VPNGENIX provides military-grade digital sovereignty for the modern era. We engineer our infrastructure with rigorous standards to ensure your privacy, security, and online freedom remain uncompromised in an increasingly connected world.
            </p>
          </motion.div>
        </div>
      </div>

      {}
      <PulseDivider />
      
      {}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[200px] bg-primary/5 blur-[100px] rounded-lg pointer-events-none" aria-hidden="true" />
    </section>;
}